// Verouderde gegevens uit het CMS: mailadres en de oude trainingslocatie.
const textFixes = [
  [/brenda@goinsideout\.nl/g, 'info@goinsideout.nl'],
  [/Schipholweg 641\s*\n\s*1175 ?KP +Lijnden(\s*\nHet gebouw is een witte kerk van Wortell)?/g, 'Omgeving Haarlem of Almere'],
  [/— Adres voorlichting/g, '— Locatie'],
];

const fixText = (value) => textFixes.reduce((text, [from, to]) => text.replace(from, to), value);

const cleanRichText = (node) => {
  if (!node || typeof node !== 'object') return node;
  const cleaned = { ...node };
  if (node.nodeType === 'text') cleaned.value = fixText(node.value || '');
  if (node.data && node.data.uri) cleaned.data = { ...node.data, uri: fixText(node.data.uri) };
  if (Array.isArray(node.content)) cleaned.content = node.content.map(cleanRichText);
  return cleaned;
};

export default cleanRichText;
